<script>
import {Bar} from 'vue-chartjs';

export default {
    extends: Bar,

    props: {
        song: {default: false},
        chartId: {default: 'media-canvas'},
        events: {default: false},
        rawData: {default: false},
        media: {default: false},
        filter: { default: 'daily'},
        period: {default: 'months'},
        fill: {default: false}
    },

    mounted(){
        this.storeData();
    },

    data() {
        return {
            data: null,
            settings: {
                total_streams: { counter: 'views', color: "#3acece", gradient: {"0.6": "#3acece", "0.9": "#3acece"}},
                youtube: { counter: 'views', color: "#d93826", gradient: {"0.6": "#eab4ae", "0.9": "#d93826"}},
                soundcloud: { counter: 'plays', color: "#e68619" },
                shazam: { counter: 'shazams', color: "#0088ff" },
                spotify_plays: { counter: 'plays', color: '#57bb63', gradient: {"0.3": "#92d39a", "0.9": "#57bb63"}},
                spotify: {counter: 'followers', color: "#57bb63" },
                spotify_playlists: { counter: 'playlists', color: "#57bb63" },                
                warm_music: { counter: 'plays', color: '#2a2d32EE', gradient: {"0.3": "#1f2136c0", "0.9": "#1f2136"}},
                apple_music: { counter: 'plays', color: '#027497', gradient: {"0.3": "#1ac7fc", "0.9": "#027497"}}
            }
        }
    },

    methods: {
        storeData() {
            if (!document.getElementById(`${this.chartId}`)) return;
            var ctx = document.getElementById(`${this.chartId}`).getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, 0, 300);

            $.each(this.settings[this.media].gradient, (opacity, color) => {
                gradient.addColorStop(opacity, color);
            });

            var pointRadius = [];
            var pointBorderWidth = [];
            var pointBackgroundColor = [];
            var pointBorderColor = [];

            $.each(this.rawData.datasets, (i, value) => {
                pointRadius.push( ( this.isOwnSong && this.getEvent(this.rawData.labels[i])) ? 6 : 2 );
                pointBackgroundColor.push( ( this.isOwnSong && this.getEvent(this.rawData.labels[i])) ? '#FFF' : this.settings[this.media].color );
            })

            this.data = {
                labels: this.rawData.labels,
                datasets: [{
                    label: this.settings[this.media].counter,
                    data: this.rawData.datasets,

                    backgroundColor: gradient,
                    borderColor: this.settings[this.media].color,
                    borderWidth: this.fill ? 1 : 2,
                    showLine: true, // show line in scatter plot
                    fill: this.fill, // only show line
                    lineTension: this.fill ? 0.2 : 0.3,
                    spanGaps: true,

                    pointBackgroundColor: pointBackgroundColor,
                    pointBorderColor: this.settings[this.media].color,
                    pointBorderWidth: 2,
                    pointRadius: this.fill ? 0 : pointRadius,

                    // pointHitRadius: 5,
                    pointHoverBackgroundColor: '#FFF',
                    pointHoverBorderColor: this.settings[this.media].color,
                    pointHoverBorderWidth: 11,
                    pointHoverRadius: 3
                }],
            }

            this.renderChart(this.data, this.options);
        },

        minTick() {
            return parseInt(Math.max(0, (4 * this.minValue() - this.maxValue()) / 3));
        },

        maxTick() {
            return (4 * this.maxValue() - this.minValue()) / 3;
        },

        getEvent(date){
            var filtered = $.grep(this.events, (e) => { return e.date == date; });
            return filtered.length ? filtered[0] : false;
        },

        minValue() { 
            return !this.rawData.datasets.length ? 0 : this.rawData.datasets.filter(function(item) {return item >= 0;})
                                                                           .reduce(function(a, b) {return Math.min(a, b);});
        },

        maxValue() {
            return !this.rawData.datasets.length ? 0 : this.rawData.datasets.filter(function(item) {return item >= 0;})
                                                                           .reduce(function(a, b) {return Math.max(a, b);});
        }
    },

    computed: {
        options() {
            var lastIndex = false;
            var that = this;

            return {
                response: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                animation:{
                    duration: 500,
                    easing: 'linear'
                },

                scales: {
                    xAxes: [{
                        position: 'bottom',
                        ticks: {
                            // display: this.period != 'months' && this.period == 'year',
                            fontColor: "#888",
                            fontSize: 13,
                            fontFamily: "Source Sans Pro",
                            autoSkip: false,
                            padding: 10,
                            maxRotation: 0,
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
                                var date = new Date(value);

                                if ( this.filter == 'daily'){
                                    if (this.period == 'week' || this.period == 'day'){
                                        return date.getDate();
                                    }else{
                                        return date.getDate() % 5 == 0 ? date.getDate() : "";
                                    }
                                }

                                if ( this.filter == 'weekly'){
                                    return date.getWeek();
                                }

                                if ( this.filter == 'monthly'){
                                    if (this.period == 'year'){
                                        return date.getMonth() % 2 == 0 ? months[date.getMonth()] : "";
                                    }else{
                                        return months[date.getMonth()];
                                    }
                                }
                            },
                        },
                        gridLines: {
                            drawBorder: true,
                            drawTicks: false,
                            display: false
                        },
                    }],
                    yAxes: [{
                        ticks: {
                            display: true,
                            fontColor: "#ccc",
                            fontSize: 10,
                            fontFamily: "Source Sans Pro",
                            autoSkip: true,
                            padding: 10,
                            maxRotation: 0,
                            beginAtZero: true,
                            maxTicksLimit: 5,
                            callback: (value, index, values) => {
                                if (value > 1000000) return (value / 1000000).toFixed(1) +'M';
                                if (value > 1000) return (value / 1000).toFixed(0) +'K';
                                if (value > 0) return value;
                            },
                            // precision: 0,
                            min: this.minTick(),
                            suggestedMin: this.minTick(),
                            suggestedMax: this.maxTick(),
                        },
                        gridLines: {
                            color: "#EEE",
                            drawBorder: false,
                            display: true,
                        },
                    }],
                },

                tooltips: {
                    enabled: false
                },

                animation: {
                    onComplete(){
                        var ctx = this.chart.ctx;
                        ctx.font = "12px Open Sans";
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';
                        ctx.fillStyle = '#444';
                        
                        var d = new Date(this.chart.config.data.labels[1]);
                        var v = this.chart.config.data.datasets[0].data[1];
                        var text1 = moment(d).format("dddd, MMMM Do");
                        var text2 = v.toFixed().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") +' '+ this.chart.config.data.datasets[0].label;

                        console.log(this.chart); 

                        this.data.datasets.forEach((dataset) => {
                            for (var i = 0; i < dataset.data.length; i++) {
                                var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                                    scale_max = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._yScale.maxHeight;

                                ctx.fillText(text1, model.x, model.y - 20);
                                ctx.fillText(text2, model.x, model.y - 5);
                            }
                        });               
                    }
                },

                onClick: (ev, chart) => {
                    // only of own song
                    if ( this.isOwnSong && chart[0] ){

                        var data = {
                            graph: this.media,
                            label: this.data.datasets[0].label,
                            count: this.data.datasets[0].data[chart[0]._index],
                            day: this.data.labels[chart[0]._index],
                        }

                        this.$root.$emit('showSongEventModal', data, this.events );
                    }
                }
            };
        },

        isOwnSong(){
            return this.song ? (this.song.uploader_id == App.user.id) : false;
        },
    },

    watch: {
        rawData(){
            this.storeData();
        },

        events(){
            if (this.rawData){
                this.storeData();
            }
        }
    }
}
</script>
